export const isImageFile = (filename: string) =>
  /\.(jpg|jpeg|png|gif)$/i.test(filename)
